import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PDPModal from '../../generic/product/PDPModal';
import { togglePdpModal } from './actions_creators';
import { useProductDietaryIngredients } from '../../../../../pages/spa/hooks/useProductDietaryIngredients';
import { log } from '@hungryroot/o11y';

const PDPModalContainer = (props) => {
  // TODO:
  // - We would never show it when props.product is null
  //   so .visible might be redundant

  const dispatch = useDispatch();
  const productId = props?.product?.id;
  const { data: dietaryProductIngredients } = useProductDietaryIngredients(
    productId,
    { enabled: Boolean(productId) }
  );

  useEffect(() => {
    if (props.product) {
      log('modals-deprecated', {
        type: 'PDPModalContainer',
        props,
      });
    }
  }, [props]);

  return props.product ? (
    <PDPModal
      {...props}
      onClose={() => dispatch(togglePdpModal(null))}
      dietaryProductIngredients={dietaryProductIngredients}
    />
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    product: state.pdpModal.product,
    visible: state.pdpModal.visible,
  };
};

export default connect(mapStateToProps)(PDPModalContainer);
